import { Image, Paragraph, Text } from '@zillow/constellation-10';
import { IconEditFilled } from '@zillow/constellation-icons';
import { Box, Card, Icon } from '@zillow/constellation-10';
import masterCardImage from '@assets/mastercard.png';
import visaImage from '@assets/visa.png';
import discoverImage from '@assets/discover.png';
import amexImage from '@assets/amex.png';
import { HiddenText } from '@common/components/HiddenText/HiddenText';

interface PaymentMethodModuleProps {
  withBackground?: boolean;
  accountLast4?: string;
  accountName?: string;
  editable?: boolean;
  displayHiddenText?: boolean;
  onClick?: () => any;
}

const PaymentMethodModule = ({
  accountName = '',
  accountLast4,
  editable,
  withBackground,
  displayHiddenText,
  onClick,
}: PaymentMethodModuleProps) => {
  const CustomContainer = ({ children }) => {
    if (withBackground) {
      return (
        <Card css={{ padding: '16px' }} elevated={false}>
          {children}
        </Card>
      );
    } else {
      return <div>{children}</div>;
    }
  };
  const getCardImage = (brand: string) => {
    const cardImageMapping = {
      Visa: visaImage,
      MasterCard: masterCardImage,
      Discover: discoverImage,
      'American Express': amexImage,
    };

    return cardImageMapping[brand] ? (
      <Image alt="card-image" css={{ height: '15px', verticalAlign: 'middle' }} src={cardImageMapping[brand]} />
    ) : null;
  };

  const handleEditClick = (e: any) => {
    e.preventDefault();
    if (onClick) {
      onClick();
    }
  };
  if (displayHiddenText) {
    return (
      <div
        style={{
          display: withBackground ? 'block' : 'inline-block',
        }}
      >
        <CustomContainer>
          <Paragraph textStyle="body-bold" className="fs-exclude">
            Payment method
          </Paragraph>
          <Text className="fs-exclude">
            <HiddenText visible={displayHiddenText} />
          </Text>
        </CustomContainer>
      </div>
    );
  }

  if (!editable) {
    return (
      <div
        style={{
          display: withBackground ? 'block' : 'inline-block',
        }}
      >
        <CustomContainer>
          <Paragraph textStyle="body-bold" className="fs-exclude">
            Payment method
          </Paragraph>
          <Box css={{ display: 'flex', alignItems: 'center', gap: 'tighter' }}>
            {getCardImage(accountName)}
            <Text className="fs-exclude">
              {accountName} •••• {accountLast4}
            </Text>
          </Box>
        </CustomContainer>
      </div>
    );
  }

  return (
    <div
      onClick={handleEditClick}
      style={{
        cursor: 'pointer',
        display: withBackground ? 'block' : 'inline-block',
      }}
    >
      <CustomContainer>
        <Paragraph textStyle="body-bold" css={{ cursor: 'pointer' }} className="fs-exclude">
          Payment method <Icon size="sm" css={{ color: 'brand' }} render={<IconEditFilled />} />
        </Paragraph>
        <Box css={{ display: 'flex', alignItems: 'center', gap: 'tighter' }}>
          {getCardImage(accountName)}

          <Text className="fs-exclude">
            {accountName} •••• {accountLast4}
          </Text>
        </Box>
      </CustomContainer>
    </div>
  );
};

export default PaymentMethodModule;
